module.exports = __webpack_public_path__ + "img/story-docker.87c4ef2a.svg";